import React from 'react';
import { GiDramaMasks } from 'react-icons/gi';

/**
 * TheaterMasksIcon
 * Ikona divadelných masiek pre reprezentáciu kultúrnych podujatí.
 */
const TheaterMasksIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <GiDramaMasks className={className} {...props} />
);

export default TheaterMasksIcon;

